export enum EmailImportListTabsEnum {
  INBOX = 'inbox',
  IMPORTED = 'imported',
  DELETED = 'deleted',
  BLOCKED = 'blocked',
}
